import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { updateLead, getLeadDetails } from "../../redux/services/leadServices/Lead.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { STATUS_OPTIONS } from "../../Constant/leadConstent";

function UpdateStatus() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  const [formData, setFormData] = useState({
    status: "",
    remarks: "",
    followup_date: "",
  });

  // 🔥 1. FETCH LEAD BY ID
  const fetchLead = async () => {
    try {
      setFetching(true);

      const res = await getLeadDetails(id);
      const lead = res.data?.data || res.data;

      setFormData({
        status: lead?.status || "",
        remarks: lead?.remarks || "",
        followup_date: lead?.next_followup || "",
      });

    } catch (err) {
      console.log(err);
      errorToast("Lead fetch failed ❌");
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    fetchLead();
  }, [id]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // 🔥 2. UPDATE API
  const handleSubmit = async () => {
    try {
      setLoading(true);

      const payload = {
        id: Number(id),
        status: formData.status,
        remarks: formData.remarks,
        date: formData.followup_date,
      };

      await updateLead(payload);

      successToast("Status Updated Successfully 🚀");
      navigate(-1);

    } catch (err) {
      console.log(err);
      errorToast("Update Failed ❌");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return <h4 className="text-center mt-5">Loading Lead...</h4>;
  }

  return (
    <div className="card p-3">

      {/* STATUS */}
      <div className="mb-3">
        <label>Status</label>

        <select
          name="status"
          className="form-select"
          value={formData.status}
          onChange={handleChange}
        >
          <option value="">Select Status</option>

          {STATUS_OPTIONS.map((item) => (
            <option key={item.value} value={item.value}>
              {item.value}
            </option>
          ))}
        </select>
      </div>

      {/* REMARK */}
      <div className="mb-3">
        <label>Remark</label>
        <textarea
          name="remarks"
          className="form-control"
          rows="3"
          value={formData.remarks}
          onChange={handleChange}
        />
      </div>

      {/* FOLLOWUP */}
      <div className="mb-3">
        <label>Followup Date</label>
        <input
          type="date"
          name="followup_date"
          className="form-control"
          value={formData.followup_date}
          onChange={handleChange}
        />
      </div>

      {/* BUTTONS */}
      <div className="d-flex gap-2">
        <button className="btn btn-light" onClick={() => navigate(-1)}>
          Cancel
        </button>

        <button
          className="add-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Status"}
        </button>
      </div>

    </div>
  );
}

export default UpdateStatus;